import React from 'react';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import Loader from '../../../../components/Loader/Loader'

import WhyHostFormBlock4 from '../../../../components/siteadmin/WhyHostPageSettings/WhyHostFormBlock4/WhyHostFormBlock4'
import getWhyHostPageSettings from './getWhyHostPageSettings.graphql';
import { withQuery } from '../../../../hoc/withGraphql';

import s from './WhyHostBlock4.css';

const WhyHostBlock4 = (props) => {

    const { data: { loading, getWhyHostPage }, title } = props;
    if (loading) return <Loader type={"text"} />;

    let settingsCollection = {};
    const dynamicMap = {};

    const BLOCK4_ACTIVE_FIELDS = ['easyHostTitle1', 'easyHostContent1', 'easyHostContent2', 'workTitle1', 'workContent1', 'workTitle2', 'workContent2'];
    getWhyHostPage?.forEach((item) => {
        settingsCollection[item.name] = item.value;

        if (BLOCK4_ACTIVE_FIELDS.includes(item.name)) {
            item.dynamicWhyHostInfoBlock?.forEach((dynItem) => {
                if (!dynamicMap[dynItem.language]) {
                    dynamicMap[dynItem.language] = { language: dynItem.language };
                }
                dynamicMap[dynItem.language][dynItem.name] = dynItem.value;
            });
        }
    });

    const dynamicValues = Object.values(dynamicMap);

    settingsCollection.dynamicWhyHostInfoBlock = dynamicValues.length > 0
        ? dynamicValues
        : [{
            language: 'en',
            easyHostTitle1: settingsCollection.easyHostTitle1,
            easyHostContent1: settingsCollection.easyHostContent1,
            easyHostContent2: settingsCollection.easyHostContent2,
            workTitle1: settingsCollection.workTitle1,
            workContent1: settingsCollection.workContent1,
            workTitle2: settingsCollection.workTitle2,
            workContent2: settingsCollection.workContent2,
        }];

    return <WhyHostFormBlock4 initialValues={settingsCollection} title={title} />;
}

WhyHostBlock4.defaultProps = {
    data: {
        loading: false
    }
};

export default compose(
    withStyles(s),
    withQuery(getWhyHostPageSettings, {
        options: {
            fetchPolicy: 'network-only',
            ssr: false
        }
    }),
)(WhyHostBlock4);